require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-code-fellows-team.json") })
        }
      }, "path---blog-author-code-fellows-team");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-code-fellows-team!./.cache/json/blog-author-code-fellows-team.json
// module id = 618
// module chunks = 231608221292675